// The shop drawings toolbar's advanced filter (owner, 2026-10-15: "the
// advanced filter for shop drawings too, to detect name, activity and same
// capability" as the issue list).
import { url, tokenRef } from "api";

const authHeader = () => {
  const userToken = localStorage.getItem(tokenRef);
  return userToken ? { Authorization: `Bearer ${userToken}` } : {};
};

/** The drawings by area sign-off for one stage and day →
 *  { stageLabel, asOf, counts: { signed, open, none }, areas: [...] } */
export const getShopDrawingAreaSignOff = async (projectId, { areaStage, areaSignOffAsOf, areaSignOffSource } = {}) => {
  const qs = new URLSearchParams();
  if (areaStage) qs.set("areaStage", areaStage);
  if (areaSignOffAsOf) qs.set("areaSignOffAsOf", areaSignOffAsOf);
  if (areaSignOffSource) qs.set("areaSignOffSource", areaSignOffSource);
  const r = await fetch(`${url}/projects/${projectId}/shop-drawings/area-sign-off${qs.toString() ? `?${qs}` : ""}`, { headers: authHeader() });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(data.err || "Could not read area sign-off");
  return data;
};

/** A filter object -> the table's own query string (filters=1 + the keys),
 *  empties left out. What a saved filter stores, and what the exports and
 *  the contractor cost page send. */
export const shopDrawingFilterQuery = (filters = {}) => {
  const qs = new URLSearchParams({ filters: "1" });
  for (const [k, v] of Object.entries(filters || {})) {
    if (v === undefined || v === null || v === "" || (Array.isArray(v) && !v.length)) continue;
    qs.set(k, Array.isArray(v) ? v.join(",") : String(v));
  }
  return qs.toString();
};

/** The areas, packages and levels of the drawings this caller can see, for a
 *  page that filters by them without holding the drawings (Document Control).
 *  -> { areas, packages, levels, ownerSide } */
export const getShopDrawingFacets = async (projectId) => {
  const r = await fetch(`${url}/projects/${projectId}/shop-drawings/facets`, { headers: authHeader() });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(data.err || "Could not read the shop drawing filters");
  return data;
};
